import { render } from "./EditRegisterLayout.vue?vue&type=template&id=08b0ea1c"
import script from "./EditRegisterLayout.vue?vue&type=script&lang=js"
export * from "./EditRegisterLayout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__